<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="toc" id="rintro"><a class="xref" href="#/wsuscheibel0008#intro">Introduction: “The Girl in the Portrait”</a></p>
<p class="toc1" id="rahintro01"><a class="xref" href="#/wsuscheibel0008#ahintro01">Interpreting Star Images and Subjectivities</a></p>
<p class="toc1" id="rahintro02"><a class="xref" href="#/wsuscheibel0008#ahintro02">Hollywood and the U.S. Home Front in the 1940s</a></p>
<p class="toc1" id="rahintro03"><a class="xref" href="#/wsuscheibel0008#ahintro03">Gene Tierney’s Star Buildup and Her “First Modern Role”</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/wsuscheibel0009#ch01">1. Working It: Beautification and War Effort</a></p>
<p class="toc1" id="rah0101"><a class="xref" href="#/wsuscheibel0009#ah0101">Gene Tierney Goes to War: <i>Thunder Birds</i> and <i>China Girl</i></a></p>
<p class="toc1" id="rah0102"><a class="xref" href="#/wsuscheibel0009#ah0102">Office Politics: The Making of <i>Laura</i> and Tierney’s Image Makeover</a></p>
<p class="toc1" id="rah0103"><a class="xref" href="#/wsuscheibel0009#ah0103"><i>Laura</i> as War(drobe) Film: Bonnie Cashin’s Costumes</a></p>
<p class="toc1" id="rah0104"><a class="xref" href="#/wsuscheibel0009#ah0104">Coda: <i>A Bell for Adano</i></a></p>
<p class="toc" id="rch02"><a class="xref" href="#/wsuscheibel0010#ch02">2. Women on the Edge: Demobilization and Domesticity</a></p>
<p class="toc1" id="rah0201"><a class="xref" href="#/wsuscheibel0010#ah0201">The Dark Side of the Moon: <i>Leave Her to Heaven</i></a></p>
<p class="toc1" id="rah0202"><a class="xref" href="#/wsuscheibel0010#ah0202">Gene &amp; Ty: <i>The Razor’s Edge</i> and <i>That Wonderful Urge</i></a></p>
<p class="toc" id="rch03"><a class="xref" href="#/wsuscheibel0011#ch03">3. The Front Lines of Life and Death: Motherhood and Mortality</a></p>
<p class="toc1" id="rah0301"><a class="xref" href="#/wsuscheibel0011#ah0301">Boom Years: The U.S. Maternal Ideal and Gene Tierney as Star Mother</a></p>
<p class="toc1" id="rah0302"><a class="xref" href="#/wsuscheibel0011#ah0302">The Redemptive Maternal: <i>Heaven Can Wait</i></a></p>
<p class="toc1" id="rah0303"><a class="xref" href="#/wsuscheibel0011#ah0303">Maternal Plentitude: <i>Dragonwyck</i></a></p>
<p class="toc1" id="rah0304"><a class="xref" href="#/wsuscheibel0011#ah0304">The Resisting Maternal: <i>The Ghost and Mrs. Muir</i></a></p>
<p class="toc" id="rch04"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><a class="xref" href="#/wsuscheibel0012#ch04">4. Into the Whirlpool: Psychological Disorder and Rehabilitation</a></p>
<p class="toc1" id="rah0401"><a class="xref" href="#/wsuscheibel0012#ah0401">Gene Tierney Reframed: Publicity and Press Commentary</a></p>
<p class="toc1" id="rah0402"><a class="xref" href="#/wsuscheibel0012#ah0402">Playacting and Sleepwalking: <i>Whirlpool</i></a></p>
<p class="toc" id="rconc"><a class="xref" href="#/wsuscheibel0013#conc">Conclusion: The Reproducible Gene Tierney</a></p>
<p class="tocbmf" id="racknow"><a class="xref" href="#/wsuscheibel0014#acknow">Acknowledgments</a></p>
<p class="tocbm" id="rnotes"><a class="xref" href="#/wsuscheibel0015#notes">Notes</a></p>
<p class="tocbm" id="rch05"><a class="xref" href="#/wsuscheibel0016#ch05">Gene Tierney’s Credits</a></p>
<p class="toc1" id="rahaft0501"><a class="xref" href="#/wsuscheibel0016#ahaft0501">Film</a></p>
<p class="toc1" id="rah0501"><a class="xref" href="#/wsuscheibel0016#ah0501">Television</a></p>
<p class="tocbm" id="rsel_bib"><a class="xref" href="#/wsuscheibel0017#sel_bib">Selected Bibliography</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/wsuscheibel0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-scheibel-0007.vue?5c6d8ccb